import CookieStore from 'ember-simple-auth/session-stores/cookie';

import cookieDomain from 'register-partners-js/utils/shared-cookie-domain';

export default class SessionStore extends CookieStore {
  cookieDomain = cookieDomain;
}
